import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/copyRight.png'


const _withScopeId = n => (_pushScopeId("data-v-73083f3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[320px] bg-opPrimary text-opWhite flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "flex h-[270px] w-[1000px]" }
const _hoisted_3 = { class: "flex-2 flex items-center" }
const _hoisted_4 = { class: "content-link" }
const _hoisted_5 = { class: "content-link" }
const _hoisted_6 = { class: "content-link" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-opTextSecond w-[1200px]" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center py-[16px] text-opTextThird" }, [
  /*#__PURE__*/_createTextVNode(" 顺丰国际版权所有 Copyright "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createTextVNode(" 2022 sf-express.com Inc. All rights reserved. 粤ICP备08034243号 ")
], -1))

import Axios from 'axios'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/app'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SfFooter',
  setup(__props) {

const app = useAppStore()
const { locale, t } = useI18n()
const isZh = ref(locale.value === 'zh-CN')
const router = useRouter()
const junmpToWebSite = (str:string) => {
  window.open(str, '_blank')
}
const jumpToDoc = () => {
  router.push({
    path: '/document',
    query: {
      firstMenu: 'API'
    }
  })
}
const jumpToAssist = async () => {
  try {
    app.changeLoading(true)
    const { data: resData } = await Axios.get('/openapi/console/noLogin/online/doc/default/guide')
    app.changeLoading(false)
    router.push({
      path: '/document',
      query: {
        firstMenu: 'GUIDE',
        secondMenu: resData.data
      }
    })
  } catch (error) {
    app.changeLoading(false)
  }
}

const jumpToQs = () => {
  router.push({
    path: '/question'
  })
}


return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_svg_icon, {
          name: "logo",
          width: 152,
          height: 46
        }),
        _createVNode(_component_svg_icon, {
          class: "mx-[40px]",
          name: isZh.value?'lgcn':'lgen',
          width: 72,
          height: 26
        }, null, 8, ["name"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('footer.document')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ()=>jumpToDoc())
          }, _toDisplayString(_unref(t)('footer.apiDoc')), 1),
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ()=>jumpToAssist())
          }, _toDisplayString(_unref(t)('footer.accessAssist')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('footer.question')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ()=>jumpToQs())
          }, _toDisplayString(_unref(t)('footer.technologyHelp')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('footer.friendLint')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ()=>junmpToWebSite('https://www.sf-international.com/'))
          }, _toDisplayString(_unref(t)('footer.sfInternetWeb')), 1),
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[4] || (_cache[4] = ()=>junmpToWebSite('http://v.sf-express.com/web/laas/home'))
          }, _toDisplayString(_unref(t)('footer.servicewebLink')), 1),
          _createElementVNode("div", {
            class: "text-opTextThird cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ()=>junmpToWebSite('https://www.sf-express.com/'))
          }, _toDisplayString(_unref(t)('footer.sfwebLink')), 1),
          (_unref(locale)==='zh-CN')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-opTextThird cursor-pointer",
                onClick: _cache[6] || (_cache[6] = ()=>junmpToWebSite('https://qiao.sf-express.com/'))
              }, _toDisplayString(_unref(t)('footer.sfOpenLink')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_7,
    _hoisted_8
  ]))
}
}

})